import { IoIosCheckmarkCircle } from 'react-icons/io';
import { RxCrossCircled } from 'react-icons/rx';

import { SubscriberPlanEnum } from '@/interfaces/entities/subscription.';
import { IUser } from '@/interfaces/entities/user';

export const subscriptionStatus = (user: IUser, flexDirection = 'flex-col') => {
	if (user.subscription?.isPlanCancelled)
		return (
			<div className={`${flexDirection} items-center justify-center`}>
				<RxCrossCircled
					className={`inline-block align-middle text-red-500`}
					title="Subscription Cancelled"
					size={22}
				/>
				<div className="text-xs text-gray-400">Cancelled</div>
			</div>
		);

	switch (user.subscription?.activePlan) {
		case SubscriberPlanEnum.NONE:
			return (
				<div className={`${flexDirection} items-center justify-center`}>
					<RxCrossCircled
						className={`inline-block align-middle text-red-500`}
						title="Subscription expired"
						size={22}
					/>
					<div className="text-xs text-gray-400">Expired</div>
				</div>
			);
		case SubscriberPlanEnum.PREMIUM:
			return (
				<div className={`${flexDirection} items-center justify-center`}>
					<IoIosCheckmarkCircle
						className={`text-yellow-300 inline-block align-middle`}
						title="Premium"
						size={22}
					/>
					<div className="text-xs text-gray-400">Premium</div>
				</div>
			);
		case SubscriberPlanEnum.THERAPIST_A:
			return (
				<div
					className={`${flexDirection} items-center justify-center text-center`}
				>
					<IoIosCheckmarkCircle
						className={`text-yellow-300 inline-block align-middle`}
						title="Plan A"
						size={22}
					/>
					<div className="text-xs text-gray-400">Plan A</div>
				</div>
			);
		case SubscriberPlanEnum.THERAPIST_B:
			return (
				<div className={`${flexDirection} items-center justify-center`}>
					<IoIosCheckmarkCircle
						className={`text-yellow-300 inline-block align-middle`}
						title="Plan B"
						size={22}
					/>
					<div className="text-xs text-gray-400">Plan B</div>
				</div>
			);
	}
};
